import { useCallback } from 'react';
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { useTemplateVariables } from "../TemplateVariablesContext";
import { useInsertVariableIntoQuill } from "./useInsertVariableIntoQuill";
import { useQuillKeyboardTrigger } from "./useQuillKeyboardTrigger";
import { useVariablePicker } from "./useVariablePicker";
import "../TemplateVariableBlot/TemplateVariableBlot";
export function useRichTextVariableIntegration(editorElRef) {
  var _config$keyboardEnabl;
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    TEMPLATE_VARIABLES
  } = useFeatureFlags();
  const {
    customVariables
  } = useTemplateVariables();
  const {
    pickerState,
    openPicker,
    closePicker
  } = useVariablePicker();
  const enabled = !!TEMPLATE_VARIABLES;
  const handleInsertVariable = useInsertVariableIntoQuill(editorElRef);
  const keyboardEnabled = enabled && ((_config$keyboardEnabl = config.keyboardEnabled) !== null && _config$keyboardEnabl !== void 0 ? _config$keyboardEnabl : true);
  useQuillKeyboardTrigger(editorElRef, openPicker, handleInsertVariable, keyboardEnabled);
  const handleOpenVariablePicker = useCallback(e => {
    openPicker(e.currentTarget, handleInsertVariable);
  }, [openPicker, handleInsertVariable]);
  const handleSelect = useCallback(label => {
    var _pickerState$onInsert;
    (_pickerState$onInsert = pickerState.onInsert) === null || _pickerState$onInsert === void 0 || _pickerState$onInsert.call(pickerState, label);
    closePicker();
  }, [pickerState, closePicker]);
  const handleClose = useCallback(() => {
    var _pickerState$onDismis;
    (_pickerState$onDismis = pickerState.onDismiss) === null || _pickerState$onDismis === void 0 || _pickerState$onDismis.call(pickerState);
    closePicker();
  }, [pickerState, closePicker]);
  return {
    enabled,
    toolbarButtonProps: {
      onClick: handleOpenVariablePicker,
      disabled: config.disabled,
      testId: config.testId
    },
    pickerPopoverProps: {
      anchorEl: pickerState.anchorEl,
      customVariables,
      onSelect: handleSelect,
      onClose: handleClose
    }
  };
}